export default __webpack_public_path__ + "static/media/banner-h.62959d9f.png";